import { render, staticRenderFns } from "./BedroomsDropdown.vue?vue&type=template&id=ea2b5e82&scoped=true&"
import script from "./BedroomsDropdown.vue?vue&type=script&lang=js&"
export * from "./BedroomsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./BedroomsDropdown.vue?vue&type=style&index=0&id=ea2b5e82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2b5e82",
  null
  
)

export default component.exports